var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2472_8628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6237 2.49993H4.3737C4.12583 2.4763 3.8785 2.55007 3.68407 2.70561C3.48964 2.86115 3.36338 3.08626 3.33203 3.33327V27.4999H11.6654V3.33327C11.634 3.08626 11.5078 2.86115 11.3133 2.70561C11.1189 2.55007 10.8716 2.4763 10.6237 2.49993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1404 25.9084L22.357 10.6584C22.3182 10.5561 22.2596 10.4624 22.1845 10.3827C22.1095 10.3031 22.0195 10.239 21.9197 10.1941C21.8198 10.1492 21.7121 10.1244 21.6027 10.1211C21.4933 10.1179 21.3844 10.1362 21.282 10.1751L18.332 11.3251V7.50008C18.332 7.27907 18.2442 7.06711 18.088 6.91083C17.9317 6.75455 17.7197 6.66675 17.4987 6.66675H13.332V27.5001H18.332V12.2417L24.107 27.5001L28.1404 25.9084Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2472_8628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.a429e9775604eec490018f7be0c393d1.svg";
export { ForwardRef as ReactComponent };